import { Box, HStack } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AttachmentIcon } from 'Asset/icon';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import { Iteration } from 'Component/others';
import PreviewImage from 'UiKit/preview-image';

import getFileNameFromUrl from 'View/reschedule-detail/helper/getFileNameFromUrl';

import styles from './styles.module.css';

const AttachmentImage = ({ images, label, className }) => {
  const { t } = useTranslation('reschedule');
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handlePreview = (index) => {
    setSelectedImageIndex(index);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => setIsPreviewOpen(false);

  return (
    <Box className={className ?? ''}>
      <TextSemiBold mb={3}>{label}</TextSemiBold>
      <HStack spacing={4} align="stretch">
        <Iteration
          items={images}
          render={(image, index) => {
            const imageName = getFileNameFromUrl(image, index);

            return (
              <HStack
                key={index}
                spacing={3}
                className={styles['attachment__item']}
                cursor="pointer"
                onClick={() => handlePreview(index)}
                _hover={{ opacity: 0.8 }}
              >
                <Box className={styles['attachment__icon']}>
                  <AttachmentIcon width="20" height="20" />
                </Box>
                <Box className={styles['attachment__info']}>
                  <TextRegular>{imageName}</TextRegular>
                  <TextRegular className={styles['attachment__size']}>({t('clickToPreview')})</TextRegular>
                </Box>
              </HStack>
            );
          }}
        />
      </HStack>

      <PreviewImage images={images} isOpen={isPreviewOpen} onClose={handleClosePreview} initialIndex={selectedImageIndex} />
    </Box>
  );
};

export default AttachmentImage;